module.exports = __webpack_public_path__ + "img/vis_11.ff8624ad.jpg";